/**
 * Common alerts
 */
import EVENT_NAMES from '@shared/lib/constants/events';
import Emitter from '@shared/services/main/events';

/**
 * Alert unathorized message
 */
export function alertUnauthenticated() {
    Emitter.emit(EVENT_NAMES.ALERT.ERROR_DISPLAY, {
        title: 'Unauthenticated',
        message: "Sorry, you are not authenticated to this",
        options: { timer: 3000 },
    });
}


/**
 * Alert unauthenticated message
 */
export function alertUnauthorized() {
    Emitter.emit(EVENT_NAMES.ALERT.ERROR_DISPLAY, {
        title: 'Unauthorized',
        message: "Sorry, you are not authorized to this",
        options: { timer: 3000 },
    });
}

/**
 * Alert unauthenticated message
 */
export function alertSuccess({
    title = 'Save success',
    message = '',
    onResolve,
}) {
    Emitter.emit(EVENT_NAMES.ALERT.SUCCESS_DISPLAY, {
        title: title,
        message: message,
        options: { timer: 3000 },
        onResolve: onResolve,
    });
}

/**
 * Alert error
 */
export function alertError({
    title = 'Save success',
    message = '',
    onResolve,
}) {
    Emitter.emit(EVENT_NAMES.ALERT.ERROR_DISPLAY, {
        title: title,
        message: message,
        options: { timer: 10000 },
        onResolve: onResolve,
    });
}

